import {Dimensions, PixelRatio, Platform} from "react-native";

export let hexToRGB = (hex, alpha) => {
    if (hex) {
        var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

        if (alpha) {
            return "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
        } else {
            return "rgb(" + r + "," + g + "," + b + ")";
        }
    }

    return '#FFFFFF'
}
const SCREEN_WIDTH = Dimensions.get('window').width > Dimensions.get('window').height ? Dimensions.get('window').width : Dimensions.get('window').height;
// based on iPad s mini scale
const scale = SCREEN_WIDTH / 760;

export function actuatedNormalize(size) {
    const newSize = size * scale;
    let returnValue;
    if (Platform.OS === 'ios') {
        returnValue = Math.round(PixelRatio.roundToNearestPixel(newSize))
    } else {
        returnValue = Math.round(PixelRatio.roundToNearestPixel(newSize)) - 2
    }

    return returnValue
}

export function actuatedWithoutScale(size) {
    return size * scale * 0.6;
}

export function setContrast({r, g, b, alpha}) {
    var o = Math.round(((parseInt(r) * 299) +
        (parseInt(g) * 587) +
        (parseInt(b) * 114)) / 1000);

    return (o > 125) ? (alpha < 0.6 ? '#FFFFFF' : '#000000') : '#FFFFFF';
}

export function setContrastDate({r, g, b, alpha}) {
    var o = Math.round(((parseInt(r) * 299) +
        (parseInt(g) * 587) +
        (parseInt(b) * 114)) / 1000);

    return (o > 125) ? (alpha < 0.6 ? '#bbbbbb' : '#717171') : '#bbbbbb';
}

export function proportionalSize(size) {
    const height = Dimensions.get('window').height;
    const width = Dimensions.get('window').width;

    let aspectRatioSize = width * height;
    let aspectRatioUnit = aspectRatioSize * 0.00001;

    return parseFloat(size) * 0.1 * aspectRatioUnit;
}